module.exports = __webpack_public_path__ + "img/comp-34.27d190bb.png";